module.exports = __webpack_public_path__ + "static/media/cont37.a02d4c2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont37.mp4
// module id = D4pF
// module chunks = 0